module.exports = __webpack_public_path__ + "img/C04WithoutNumber_ua.fcae35cf.webp";